import { ReactElement } from 'react';
import { BaseBlock } from '../../../../components/styles/Block';
import { Typography } from 'antd';

const { Title } = Typography;

interface Props {
  title: string;
}

const Header = ({ title }: Props): ReactElement => (
  <BaseBlock as='header'>
    <Title level={4}>{title}</Title>
  </BaseBlock>
);

export default Header;
